import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import { Skeleton } from '@mui/material';

export const PersonPageSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const iconpx = 26;
  const Icon = () => <Skeleton variant="rectangular" width={iconpx} height={iconpx} style={{ borderRadius: 4, marginRight: 3 }} />;

  return (
    <Container maxWidth="md">
      <Box display={"flex"} flexDirection={isMobile ? "column" : "row"} pt={3}>
        <Box display={"flex"} alignItems="center" flexDirection={"column"}>
          {/* pic & name */}
          <Skeleton variant="rectangular" width={166} height={250} style={{ borderRadius: 5 }} />
          <Skeleton variant="text" width={130} height={36} />

          {/* social media box */}
          <Box display={"flex"} className="spacing">
            <Icon />
            <Icon />
            <Icon />
          </Box>

          <Box display={"flex"} className="spacing" pt={0.8}>
            <Skeleton variant="rectangular" width={70} height={iconpx} style={{ borderRadius: 4 }} />
            <Icon />
          </Box>
        </Box>

        <Box p={isMobile ? 0 : 3} display="block" width={"100%"}>
          {/* Age, Born, Bio, etc... */}
          <Skeleton width={50} />
          <Skeleton width={100} />
          <Skeleton width={150} />
          <Skeleton variant="rectangular" height={50} style={{ width: "100%" }} />

          {/* ItemCard */}
          <Box pt={1}>
            <Skeleton width={180} height={30} style={{ margin: "auto" }} />
            <Skeleton variant="rectangular" height={isMobile ? 150 : 300} style={{ width: "100%", borderRadius: 4 }} />
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default PersonPageSkeleton;
